import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordResetComponent } from './components/password-reset/password-reset.component';
import { LoginComponent } from './components/login/login.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SecurityComponent } from './security.component';
import { SecurityRoutingModule } from './security-routing.module';
import { TooltipModule } from 'primeng/tooltip';
import { PasswordUpdateModule } from './components/password-update/password-update.module';
import { InputModule } from '../settings-v2/components/input/input.module';
import { LogoutComponent } from './components/logout/logout.component';
import { TokenErrorComponent } from './components/token-error/token-error.component';
import { ValidatorsModule } from '../shared/validators/validators.module';
import { MfaSetupComponent } from './components/mfa-setup/mfa-setup.component';
import { StandardAlertModule } from '../annuities/shared/standard-alert/standard-alert.module';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { OtpCodeModule } from '../controls/otp-code/otp-code.module';
import { MfaSetupCompleteComponent } from './components/mfa-setup-complete/mfa-setup-complete.component';
import { PipesModule } from '../shared/pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    FormsModule,
    ButtonModule,
    InputTextModule,
    SecurityRoutingModule,
    TooltipModule,
    PasswordUpdateModule,
    ValidatorsModule,
    InputModule,
    StandardAlertModule,
    ToggleButtonModule,
    InputSwitchModule,
    OtpCodeModule,
    PipesModule,
  ],
  declarations: [
    PasswordResetComponent,
    LoginComponent,
    SecurityComponent,
    LogoutComponent,
    TokenErrorComponent,
    MfaSetupComponent,
    MfaSetupCompleteComponent,
  ],
  exports: [
    PasswordResetComponent,
    LoginComponent,
  ]
})
export class SecurityModule {
}
